(function () {
  var thumbs = [];

  function collect() {
    thumbs = Array.prototype.slice.call(document.querySelectorAll('.cc-portal-thumb img'));
  }

  function update() {
    var vh = window.innerHeight;
    for (var i = 0; i < thumbs.length; i++) {
      var img = thumbs[i];
      var rect = img.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > vh + 100) continue;
      var center = rect.top + rect.height / 2;
      var offset = (center - vh / 2) / vh;
      var y = offset * 22;
      img.style.setProperty('--cc-parallax-y', y.toFixed(2) + 'px');
    }
  }

  var ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        update();
        ticking = false;
      });
      ticking = true;
    }
  }

  function init() {
    collect();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      collect();
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
